export enum NewsType {
  Club = '0',
  Group = '2',
  Chairman = '3',
}
